/**
 * Represents all possible Stream Timeline Events.
 */
export enum StreamTimelineEvent {
  // Represents the content is blacked out.
  BLACKOUT = 'blackout',

  // Represents the start of a live program event
  LIVE_PROGRAM_START = 'liveProgramStart',

  // Represents the end of a live program event
  LIVE_PROGRAM_END = 'liveProgramEnd',

  // Represents the start of a one-time live event
  LIVE_EVENT_START = 'liveEventStart',

  // Represents the end of one-time live event
  LIVE_EVENT_END = 'liveEventEnd',

  LIVE_EVENT_PROGRESS_END = 'liveEventProgressEnd',

  // Represents the overflow event end time in live event
  OVERFLOW_EVENT_END = 'overflowEventEnd',

  // Represents game metadata
  GAME_INFO = 'gameInfo',

  // Represents an event happening on the game
  GAME_EVENT = 'gameEvent',

  // Represents unknown event
  UNKNOWN = 'unknown',

  // Represents live 360 available
  LIVE_360_AVAILABLE = 'live360Available',

  // Represents live 360 unavailable
  LIVE_360_UNAVAILABLE = 'live360Unavailable',

  // Represents trition audio track info
  TRITON_AUDIO_MEDIA_TRACK = 'tritonAudioMediaTrackInfo',

  // Represents trition Ad info
  TRITON_AD = 'tritonAdInfo',

  // Represents trition audio speech info
  TRITON_AUDIO_MEDIA_SPEECH = 'tritonAudioMediaSpeechInfo',

  // Represents trition sweeper info
  TRITON_SWEEPER = 'tritonSweeperInfo',

  // SBM connection failure
  TRITON_SBM_UNAVAILABLE = 'tritonSBMUnavailable',
}
